module.exports = __webpack_public_path__ + "static/media/plus-icon.eb90c4e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus-icon.svg
// module id = 515
// module chunks = 0